export default __webpack_public_path__ + "static/media/60-YULMUSIC-TraintheCircusBeyond.835d37d7.jpg";